"use client";

// src/use-aria-progress.ts
import { clamp, filterDOMProps, mergeProps } from "@react-aria/utils";
import { useAriaLabel } from "@nextui-org/use-aria-label";
import { useNumberFormatter } from "@react-aria/i18n";
function useProgressBar(props) {
  let {
    value = 0,
    minValue = 0,
    maxValue = 100,
    valueLabel,
    isIndeterminate,
    formatOptions = {
      style: "percent"
    }
  } = props;
  const domProps = filterDOMProps(props, { labelable: true });
  const { labelProps, fieldProps } = useAriaLabel({
    ...props,
    labelElementType: "span"
  });
  value = clamp(value, minValue, maxValue);
  const percentage = (value - minValue) / (maxValue - minValue);
  const formatter = useNumberFormatter(formatOptions);
  if (!isIndeterminate && !valueLabel) {
    const valueToFormat = formatOptions.style === "percent" ? percentage : value;
    valueLabel = formatter.format(valueToFormat);
  }
  return {
    progressBarProps: mergeProps(domProps, {
      ...fieldProps,
      "aria-valuenow": isIndeterminate ? void 0 : value,
      "aria-valuemin": minValue,
      "aria-valuemax": maxValue,
      "aria-valuetext": isIndeterminate ? void 0 : valueLabel,
      role: "progressbar"
    }),
    labelProps
  };
}

export {
  useProgressBar
};
